import { ListItem } from '@tableau/widgets';
import { Messages } from '../../../gen-src/Localize';

export namespace DisplayOptions {
  export function getMixedView(): ListItem {
    return {
      value: 'mixed view',
      content: Messages.DisplayOptionMixedView(),
    };
  }

  export function getListView(): ListItem {
    return {
      value: 'list view',
      content: Messages.DisplayOptionListView(),
    };
  }
}
